
import { motion } from 'framer-motion';

export default function GolfSection() {
  const golfCourses = [
    {
      name: "Real Club Valderrama",
      location: "Sotogrande",
      distance: "1h 20min",
      image: "https://public.readdy.ai/ai/img_res/80272c8141ebd764bfe8f23edd921dd5.jpg"
    },
    {
      name: "La Quinta Golf",
      location: "Benahavís",
      distance: "45min",
      image: "https://readdy.ai/api/search-image?query=La%20Quinta%20Golf%20Resort%20Marbella%20luxury%20golf%20course%20mountain%20views%20premium%20golf%20destination%20Costa%20del%20Sol%20stunning%20fairways%20professional%20golf%20course&width=400&height=300&seq=golf-laquinta-01&orientation=landscape"
    },
    {
      name: "Los Naranjos Golf",
      location: "Nueva Andalucía",
      distance: "40min",
      image: "https://readdy.ai/api/search-image?query=Los%20Naranjos%20Golf%20Club%20Marbella%20orange%20trees%20golf%20course%20Robert%20Trent%20Jones%20design%20premium%20golf%20destination%20Costa%20del%20Sol%20beautiful%20fairways&width=400&height=300&seq=golf-naranjos-01&orientation=landscape"
    },
    {
      name: "Finca Cortesín",
      location: "Casares",
      distance: "1h 10min",
      image: "https://readdy.ai/api/search-image?query=Finca%20Cortesin%20Golf%20Club%20luxury%20resort%20championship%20golf%20course%20Ryder%20Cup%20venue%20premium%20golf%20destination%20Andalusia%20stunning%20course%20design&width=400&height=300&seq=golf-cortesin-01&orientation=landscape"
    }
  ];

  const features = [
    {
      icon: "ri-luggage-cart-line",
      title: "Amplio Espacio",
      description: "Maletero especialmente diseñado para equipos de golf completos"
    },
    {
      icon: "ri-shield-check-line",
      title: "Transporte Seguro",
      description: "Tus palos viajan protegidos y seguros durante todo el trayecto"
    },
    {
      icon: "ri-map-pin-line",
      title: "Conocemos la Zona",
      description: "Rutas directas a todos los campos de golf de la Costa del Sol"
    },
    {
      icon: "ri-time-line",
      title: "Puntualidad",
      description: "Te llevamos a tiempo para tu hora de salida en el campo"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-green-50 to-white" id="golf">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex justify-center mb-6">
            <div className="bg-green-600 text-white rounded-full p-4">
              <i className="ri-basketball-line text-3xl"></i>
            </div>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Traslados para <span className="text-green-600">Golfistas</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
            Especialistas en transporte para amantes del golf. Te llevamos a los mejores campos de la Costa del Sol con tu equipo completo, cómodo y seguro.
          </p>
          <div className="bg-green-100 text-green-700 px-8 py-3 rounded-full font-semibold inline-block">
            <i className="ri-golf-ball-line mr-2"></i>
            Espacio para bolsas de golf, carritos y equipamiento completo
          </div>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="w-14 h-14 bg-green-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Golf Courses */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Te llevamos a los <span className="text-green-600">Mejores Campos</span>
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {golfCourses.map((course, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
              >
                <div className="relative">
                  <img
                    src={course.image}
                    alt={course.name}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {course.distance}
                  </div>
                </div>
                <div className="p-4">
                  <h4 className="text-lg font-bold text-gray-900 mb-1">{course.name}</h4>
                  <p className="text-gray-600 text-sm flex items-center">
                    <i className="ri-map-pin-line mr-1"></i>
                    {course.location}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Service Details */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl p-8 md:p-12 shadow-lg mb-16"
        >
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                ¿Por qué elegir nuestro servicio?
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Maletero Espacioso</h4>
                    <p className="text-gray-600 text-sm">Cabida para múltiples bolsas de golf y carritos plegables</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Conductores Expertos</h4>
                    <p className="text-gray-600 text-sm">Conocen todos los campos y las mejores rutas</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Servicio Premium</h4>
                    <p className="text-gray-600 text-sm">Vehículos Mercedes 2024 con aire acondicionado</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Recogida y Entrega</h4>
                    <p className="text-gray-600 text-sm">Te recogemos en tu hotel y te llevamos de vuelta</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Mercedes%20luxury%20minibus%20with%20golf%20bags%20in%20spacious%20trunk%20professional%20golf%20equipment%20transport%20service%20Costa%20del%20Sol%20premium%20vehicle%20golf%20clubs%20storage&width=500&height=400&seq=golf-service-01&orientation=landscape"
                alt="Transporte de equipos de golf"
                className="w-full h-80 object-cover rounded-2xl"
              />
              <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="text-green-700 font-bold">⛳ Golf Ready</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Personalized Service CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center bg-gradient-to-r from-green-600 to-green-700 rounded-3xl p-12 text-white"
        >
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-customer-service-2-line text-5xl"></i>
            </div>
            
            <h3 className="text-4xl font-bold mb-6">
              Servicio Personalizado para Golfistas
            </h3>
            
            <p className="text-xl mb-8 text-green-100 leading-relaxed">
              Cada grupo de golf es único. Contáctanos para diseñar un servicio a tu medida: traslados individuales, grupos, torneos o paquetes de varios días. Te ofrecemos la mejor atención y el servicio más completo para tu experiencia de golf en la Costa del Sol.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8">
              <p className="text-lg text-green-50 mb-4">
                <strong>Consulta sin compromiso</strong> — Te asesoramos sobre la mejor opción para tu grupo
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm text-green-100">
                <span className="flex items-center">
                  <i className="ri-check-double-line mr-2"></i>
                  Traslados individuales o grupos
                </span>
                <span className="flex items-center">
                  <i className="ri-check-double-line mr-2"></i>
                  Torneos y eventos especiales
                </span>
                <span className="flex items-center">
                  <i className="ri-check-double-line mr-2"></i>
                  Paquetes de varios días
                </span>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <a
                href="https://wa.me/34614932797?text=Hola,%20me%20interesa%20el%20servicio%20de%20traslados%20para%20golf"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
              >
                <i className="ri-whatsapp-line mr-2 text-2xl"></i>
                Consultar por WhatsApp
              </a>
              
              <a
                href="tel:+34614932797"
                className="bg-green-800 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-900 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
              >
                <i className="ri-phone-line mr-2"></i>
                614 932 797
              </a>
            </div>
            
            <p className="text-green-200 mt-6 text-sm">
              También puedes escribirnos a: <strong>info@transfermalaga.com</strong>
            </p>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
